export const legalDocuments = {
  terms: {
    title: '이용약관',
    markdown: `# 텔링파파 이용약관

<!--
운영 전 확인 필요:
- 통신판매업 신고번호를 실제 값으로 교체하세요.
- 유료 맞춤 앱 제작 상품의 청약철회 제한 여부는 결제 화면에서 별도 고지와 동의를 받아야 합니다.
- 본 문서는 서비스 구조를 기준으로 작성한 초안이므로, 배포 전 법무/개인정보 담당자 검토를 권장합니다.
-->

시행일: 2026-06-01

## 제1조(목적)

이 약관은 티브로스(이하 "회사")가 운영하는 텔링파파(Telling Papa) 웹사이트, 모바일 앱 및 관련 서비스(이하 "서비스")의 이용과 관련하여 회사와 이용자 사이의 권리, 의무 및 책임사항, 서비스 이용조건과 절차를 정하는 것을 목적으로 합니다.

## 제2조(정의)

1. "서비스"란 회사가 제공하는 맞춤 동화 생성, 동화 이미지 생성, 동화 열람, 알림, 이메일 안내, 맞춤 앱 제작 신청 및 기타 관련 기능을 말합니다.
2. "이용자"란 이 약관에 따라 서비스를 이용하는 회원 및 비회원을 말합니다.
3. "회원"이란 소셜 로그인 등 회사가 정한 절차에 따라 서비스 이용계약을 체결하고 서비스를 이용하는 자를 말합니다.
4. "보호자"란 아동의 개인정보 및 초상, 이미지, 성명, 특성 등을 서비스에 입력할 적법한 권한이 있는 부모 등 법정대리인 또는 그에 준하는 자를 말합니다.
5. "주인공"이란 이용자가 맞춤 동화 또는 맞춤 앱 제작을 위해 등록한 아동 또는 인물 프로필을 말합니다.
6. "콘텐츠"란 이용자가 입력한 정보, 회사 또는 AI 시스템이 생성한 동화, 이미지, 음성, 앱, 텍스트, 파일, 화면, 데이터 및 그 밖의 결과물을 말합니다.
7. "유료서비스"란 이용자가 대가를 지급하고 이용하는 맞춤 앱 제작 신청, 기타 유료 상품 또는 기능을 말합니다.

## 제3조(약관의 게시와 변경)

1. 회사는 이 약관의 내용을 이용자가 쉽게 확인할 수 있도록 서비스 화면 또는 연결 화면에 게시합니다.
2. 회사는 관련 법령을 위반하지 않는 범위에서 이 약관을 변경할 수 있습니다.
3. 회사가 약관을 변경하는 경우 적용일자, 변경내용 및 변경사유를 명시하여 적용일 7일 전부터 공지합니다. 이용자에게 불리하거나 중요한 사항을 변경하는 경우에는 적용일 30일 전부터 공지하고, 관련 법령에서 요구하는 경우 별도의 동의를 받습니다.
4. 이용자가 변경 약관의 적용일까지 명시적으로 거부 의사를 표시하지 않고 서비스를 계속 이용하는 경우, 관련 법령에서 달리 정하지 않는 한 변경 약관에 동의한 것으로 볼 수 있습니다.

## 제4조(약관 외 준칙)

이 약관에서 정하지 않은 사항은 개인정보 처리방침, 개별 서비스 안내, 운영정책, 전자상거래 등에서의 소비자보호에 관한 법률, 개인정보 보호법, 약관의 규제에 관한 법률 등 관계 법령 및 상관례에 따릅니다.

## 제5조(이용계약의 성립)

1. 이용계약은 이용자가 회사가 정한 방식으로 서비스 이용을 신청하고, 회사가 이를 승낙함으로써 성립합니다.
2. 회사는 다음 각 호의 어느 하나에 해당하는 경우 이용신청을 승낙하지 않거나 사후에 이용계약을 해지할 수 있습니다.
   - 타인의 명의 또는 소셜 계정을 사용한 경우
   - 허위 정보를 입력하거나 회사가 요청하는 정보를 제공하지 않은 경우
   - 아동 또는 제3자의 개인정보, 초상, 이미지, 저작물 등을 처리할 권한이 없는 경우
   - 관련 법령, 이 약관 또는 운영정책을 위반한 이력이 있는 경우
   - 서비스의 안정적 운영을 방해하거나 부정한 목적으로 신청한 경우

## 제6조(미성년자 및 아동 정보)

1. 서비스는 보호자가 아동의 정보를 입력하여 맞춤 동화 및 관련 콘텐츠를 생성하는 구조를 포함합니다.
2. 이용자는 주인공 정보, 사진, 가족·친구 관련 정보 등 아동 또는 제3자에 관한 정보를 입력하기 전에 필요한 권한과 동의를 확보해야 합니다.
3. 만 14세 미만 아동이 직접 회원으로 가입하거나 개인정보를 제공하는 경우, 회사는 관련 법령에 따라 법정대리인의 동의를 확인할 수 있습니다.
4. 이용자는 아동의 주민등록번호, 상세 주소, 학교명, 연락처, 건강정보, 민감정보 등 서비스 제공에 필요하지 않은 정보를 입력하지 않아야 합니다.

## 제7조(회원 계정 관리)

1. 회원은 본인의 계정 및 접근 토큰을 직접 관리해야 하며, 이를 제3자에게 이용하게 해서는 안 됩니다.
2. 회원은 계정 도용, 무단 이용 또는 보안 사고가 의심되는 경우 즉시 회사에 알려야 합니다.
3. 회원의 관리 소홀, 사용상 과실 또는 제3자 사용 허락으로 발생한 손해에 대하여 회사는 회사의 귀책사유가 없는 한 책임을 지지 않습니다.

## 제8조(서비스의 제공)

회사는 다음 각 호의 서비스를 제공할 수 있습니다.

1. 주인공 프로필 등록 및 관리
2. 주인공의 특성, 취향, 가족·친구 정보 등을 반영한 맞춤 동화 생성
3. 동화 삽화, 이미지 설명, 이미지 프롬프트 및 음성 등 AI 기반 콘텐츠 생성
4. 생성된 동화 및 이미지의 열람, 수정, 검토 및 공유 링크 제공
5. 동화 완성 알림, 이메일 및 푸시 알림
6. 맞춤 앱 제작 상품 조회, 결제, 제작 신청 및 결과 URL 제공
7. 기타 회사가 정하는 서비스

## 제9조(AI 생성 콘텐츠)

1. 서비스의 일부 콘텐츠는 이용자가 입력한 정보를 바탕으로 AI 시스템을 통해 자동 또는 반자동으로 생성됩니다.
2. AI 생성 콘텐츠는 부정확하거나 부적절한 표현을 포함할 수 있으며, 회사는 서비스 품질 개선을 위해 검토, 수정, 재생성 또는 제공 제한을 할 수 있습니다.
3. 이용자는 AI 생성 콘텐츠를 아동에게 제공하거나 외부에 공유하기 전에 적절성을 직접 확인해야 합니다.
4. 서비스는 교육, 의료, 심리, 법률 등 전문적 조언을 제공하는 서비스가 아니며, 이용자는 AI 생성 콘텐츠를 전문적 판단의 대체 수단으로 사용해서는 안 됩니다.
5. 회사는 관련 법령 또는 제3자의 권리를 침해하거나 아동에게 부적절하다고 판단되는 요청 또는 콘텐츠의 처리를 거절할 수 있습니다.

## 제10조(이용자의 의무)

이용자는 다음 각 호의 행위를 해서는 안 됩니다.

1. 허위 정보 입력, 타인의 계정 또는 결제수단 도용
2. 아동 또는 제3자의 개인정보, 초상, 이미지, 저작물을 권한 없이 입력·업로드·공유하는 행위
3. 주민등록번호, 금융정보, 건강정보, 위치정보, 학교명 등 서비스 제공에 불필요한 민감하거나 과도한 정보를 입력하는 행위
4. 음란, 폭력, 차별, 혐오, 학대, 범죄, 자해, 아동에게 유해한 내용의 생성 또는 유포를 요청하는 행위
5. 회사 또는 제3자의 지식재산권, 개인정보, 명예, 신용, 영업비밀을 침해하는 행위
6. 서비스의 정상 운영을 방해하거나 자동화 수단으로 과도한 요청을 보내는 행위
7. 회사의 사전 동의 없이 서비스를 영리 목적으로 재판매, 대여, 양도하거나 대량 생성에 이용하는 행위
8. 관련 법령, 이 약관, 개인정보 처리방침 또는 운영정책을 위반하는 행위

## 제11조(콘텐츠의 권리와 이용)

1. 이용자가 서비스에 입력한 원본 정보와 업로드한 콘텐츠에 대한 권리는 이용자 또는 정당한 권리자에게 귀속됩니다.
2. 이용자는 회사가 서비스 제공, AI 생성, 저장, 품질 개선, 오류 대응, 고객지원 및 분쟁 대응에 필요한 범위에서 이용자 입력 콘텐츠를 이용, 저장, 복제, 변환, 전송 및 가공할 수 있는 권한을 회사에 부여합니다.
3. 회사가 제공하는 서비스 화면, 템플릿, 캐릭터, 디자인, 소프트웨어, 데이터베이스, 동화 원형, 앱 구성 및 기타 회사 콘텐츠에 관한 권리는 회사 또는 정당한 권리자에게 귀속됩니다.
4. 이용자는 서비스에서 생성된 맞춤 동화 및 이미지를 개인적·비상업적 목적으로 이용할 수 있습니다. 상업적 이용, 재판매, 대량 배포, 출판, 광고 사용, 굿즈 제작 등은 회사와 별도 합의가 없는 한 제한됩니다.
5. 맞춤 앱 제작 결과물은 결제한 상품의 안내 범위 내에서 이용할 수 있으며, 소스코드, 운영 도구, 서버 권한, 원천 디자인 파일 등은 별도 약정이 없는 한 제공 대상에 포함되지 않습니다.

## 제12조(콘텐츠의 관리 및 삭제)

1. 회사는 이용자 콘텐츠가 관련 법령, 이 약관, 운영정책 또는 제3자의 권리를 침해한다고 판단되는 경우 사전 통지 없이 게시, 생성, 공유 또는 열람을 제한할 수 있습니다.
2. 이용자는 본인이 등록한 주인공 정보 또는 콘텐츠의 삭제를 요청할 수 있습니다. 다만 관계 법령에 따라 보존해야 하는 정보, 결제·분쟁 대응을 위해 필요한 최소 정보는 해당 기간 동안 보관될 수 있습니다.
3. 회사는 서비스 품질, 저장 공간, 보안 또는 운영상 필요에 따라 임시 이미지, 작업 파일, 실패 작업 데이터를 일정 기간 후 삭제할 수 있습니다.

## 제13조(유료서비스 및 결제)

1. 회사는 유료서비스의 상품명, 가격, 제공 내용, 제작 방식, 예상 처리 절차, 청약철회 및 환불 조건을 결제 전 화면에 표시합니다.
2. 이용자는 회사가 정한 결제수단 또는 결제대행사를 통해 유료서비스를 결제할 수 있습니다.
3. 결제 승인 후 맞춤 앱 제작 상품은 이용자가 선택한 주인공을 기준으로 제작 신청이 접수됩니다.
4. 맞춤 앱 제작 상태는 요청, 접수, 진행, 완료, 취소 등으로 표시될 수 있으며, 실제 제작은 운영자가 수동으로 접수·진행할 수 있습니다.
5. 회사는 결제 금액, 상품, 주인공, 주문번호 등 결제 검증에 필요한 정보를 서버에 저장하고, 결제대행사의 승인 또는 취소 결과를 확인합니다.

## 제14조(청약철회, 취소 및 환불)

1. 이용자는 관련 법령 및 상품별 고지사항에 따라 청약철회, 취소 또는 환불을 요청할 수 있습니다.
2. 디지털 콘텐츠 또는 이용자의 주문에 따라 개별적으로 제작되는 맞춤 앱·콘텐츠의 경우, 회사가 청약철회 제한 사유를 사전에 고지하고 이용자의 동의를 받은 뒤 제작 또는 제공이 개시되면 관련 법령이 허용하는 범위에서 청약철회가 제한될 수 있습니다.
3. 제작이 시작되기 전이거나 회사가 서비스를 제공하지 못한 경우에는 상품별 고지사항 및 관계 법령에 따라 환불합니다.
4. 표시·광고 내용과 다르거나 계약 내용과 다르게 제공된 경우 이용자는 관계 법령에 따라 청약철회 또는 환불을 요청할 수 있습니다.
5. 환불은 원칙적으로 이용자가 결제한 수단을 통해 처리하며, 결제대행사 또는 금융기관의 처리 정책에 따라 실제 환급 시점이 달라질 수 있습니다.

## 제15조(서비스의 변경, 중단)

1. 회사는 운영상, 기술상 필요에 따라 서비스의 전부 또는 일부를 변경하거나 중단할 수 있습니다.
2. 회사는 정기점검, 장애 대응, 보안 조치, 외부 API 장애, 클라우드 장애, 결제대행사 장애, 천재지변 등으로 서비스 제공이 일시 중단될 수 있음을 사전에 또는 사후에 공지할 수 있습니다.
3. 회사의 고의 또는 중대한 과실이 없는 한, 무료서비스의 변경 또는 중단으로 인한 손해에 대해 회사는 책임을 지지 않습니다.

## 제16조(이용제한 및 계약해지)

1. 이용자가 이 약관 또는 관계 법령을 위반한 경우 회사는 경고, 콘텐츠 삭제, 이용 제한, 계정 정지, 이용계약 해지 등 필요한 조치를 할 수 있습니다.
2. 회원은 언제든지 회사가 정한 절차에 따라 탈퇴를 요청할 수 있습니다.
3. 탈퇴 시 회사는 개인정보 처리방침에 따라 회원 정보를 삭제합니다. 다만 관계 법령상 보존 의무가 있거나 분쟁 대응에 필요한 정보는 해당 기간 동안 보관될 수 있습니다.

## 제17조(개인정보 보호)

회사는 서비스 제공을 위해 필요한 범위에서 개인정보를 처리하며, 개인정보 처리에 관한 사항은 별도의 개인정보 처리방침에 따릅니다.

## 제18조(회사의 책임 제한)

1. 회사는 회사의 고의 또는 중대한 과실이 없는 한 다음 각 호의 손해에 대해 책임을 지지 않습니다.
   - 이용자의 귀책사유로 발생한 서비스 이용 장애 또는 손해
   - 이용자가 입력한 정보의 오류, 부정확성, 권한 부재로 발생한 손해
   - AI 생성 콘텐츠의 부정확성 또는 이용자의 사후 활용으로 발생한 손해
   - 외부 로그인 제공자, 결제대행사, 클라우드, AI API, 푸시 알림 서비스 등 제3자 서비스의 장애 또는 정책 변경으로 발생한 손해
2. 회사는 무료로 제공되는 서비스와 관련하여 관련 법령상 허용되는 범위에서 보증 책임을 부담하지 않습니다.
3. 회사는 유료서비스와 관련하여 관련 법령상 허용되는 범위에서 상품별 고지 및 이 약관에 따른 책임을 부담합니다.

## 제19조(손해배상)

회사 또는 이용자가 이 약관이나 관계 법령을 위반하여 상대방에게 손해를 입힌 경우, 귀책 있는 당사자는 그 손해를 배상해야 합니다. 다만 회사는 이용자의 통상적이고 예견 가능한 직접 손해에 한하여 책임을 부담하며, 고의 또는 중대한 과실이 있는 경우에는 관계 법령에 따릅니다.

## 제20조(통지)

1. 회사는 이용자가 제공한 이메일, 서비스 내 알림, 푸시 알림, 공지사항 또는 기타 적절한 방법으로 이용자에게 통지할 수 있습니다.
2. 불특정 다수 이용자에 대한 통지는 서비스 내 공지사항 게시로 갈음할 수 있습니다. 다만 이용자에게 중대한 영향을 미치는 사항은 가능한 개별 통지합니다.

## 제21조(분쟁 해결)

1. 회사와 이용자는 서비스 이용과 관련하여 분쟁이 발생한 경우 성실히 협의하여 해결합니다.
2. 분쟁이 해결되지 않는 경우 이용자는 한국소비자원, 전자거래분쟁조정위원회, 개인정보분쟁조정위원회 등 관련 기관에 구제를 신청할 수 있습니다.
3. 이 약관은 대한민국 법령에 따라 해석됩니다.
4. 회사와 이용자 사이에 발생한 소송은 민사소송법 등 관계 법령에서 정한 관할 법원에 제기합니다.

## 제22조(사업자 정보)

- 상호/사업자명: 티브로스
- 대표자: 김빛나라
- 사업자등록번호: 524-10-02629
- 통신판매업 신고번호: [입력 필요]
- 주소: 제주 서귀포시 번영로 3376
- 고객센터 이메일: tbroskor@gmail.com
- 운영시간: 월~금 11:00 ~ 21:00

## 부칙

이 약관은 2026-06-01부터 시행합니다.
`,
  },
  privacy: {
    title: '개인정보 처리방침',
    markdown: `# 텔링파파 개인정보 처리방침

<!--
운영 전 확인 필요:
- 개인정보 보호책임자 또는 고객센터 정보를 추가로 공개해야 하는 경우 실제 값으로 보완하세요.
- 수탁자명, 국외 이전 국가, 보유기간은 실제 계약과 각 서비스 설정에 맞게 확인하세요.
- "개인정보취급방침"은 과거 용어이고, 현행 법령상 명칭은 "개인정보 처리방침"입니다.
- 본 문서는 서비스 구조를 기준으로 작성한 초안이므로, 배포 전 법무/개인정보 담당자 검토를 권장합니다.
-->

시행일: 2026-06-01

티브로스(이하 "회사")는 텔링파파(Telling Papa) 서비스 이용자의 개인정보를 보호하고 관련 고충을 신속하게 처리하기 위하여 개인정보 보호법 등 관계 법령에 따라 다음과 같이 개인정보 처리방침을 수립·공개합니다.

## 제1조(개인정보의 처리 목적)

회사는 다음 목적을 위해 개인정보를 처리합니다. 처리한 개인정보는 아래 목적 외의 용도로 이용하지 않으며, 이용 목적이 변경되는 경우에는 관련 법령에 따라 별도의 동의를 받는 등 필요한 조치를 이행합니다.

1. 회원 가입 및 로그인: 소셜 로그인, 회원 식별, 접근 권한 확인, 부정 이용 방지
2. 주인공 프로필 관리: 맞춤 동화와 맞춤 앱 제작을 위한 주인공 등록, 수정, 삭제, 소유자 확인
3. 맞춤 동화 및 이미지 생성: 주인공 정보와 이용자 입력 답변을 반영한 동화, 이미지, 프롬프트, 음성 등 콘텐츠 생성·검토·수정
4. 서비스 제공 및 운영: 동화 열람, 작업 상태 관리, 오류 대응, 품질 관리, 이력 관리
5. 알림 및 안내: 동화 완성 안내, 이메일 안내, 푸시 알림 발송, 수신 동의 관리
6. 유료서비스 제공: 맞춤 앱 제작 상품 결제, 결제 검증, 제작 신청 접수, 제작 상태 관리, 결과 URL 제공, 환불·취소 처리
7. 고객지원 및 분쟁 대응: 문의 응대, 민원 처리, 이용기록 확인, 법령상 의무 이행
8. 보안 및 안정성 확보: 비정상 이용 탐지, 접근 기록 관리, 서비스 장애 분석

## 제2조(처리하는 개인정보 항목)

회사는 서비스 제공에 필요한 최소한의 개인정보를 처리합니다.

| 구분 | 처리 항목 |
| --- | --- |
| 회원 가입·로그인 | 소셜 로그인 제공자, 소셜 계정 식별자, 서비스 접근 토큰, 토큰 발급·갱신 일시 |
| 보호자/회원 정보 | 회원 이름 또는 별명, 회원 번호, 가입 일시, 탈퇴 여부, 멤버십 등급 |
| 주인공 프로필 | 주인공 이름, 성, 출생연도, 성별, 사진 또는 이미지 URL, 외모 설명, 그래픽 이미지 URL, 삭제 여부 |
| 주인공 상세 답변 | 성격, 취향, 관심사, 가족·친구·반려동물 이름 등 이용자가 질문에 입력한 답변, AI용 변환 답변, 답변별 이미지 URL |
| 동화 생성·열람 | 동화 제목, 내용, 페이지 번호, 이미지 URL, 이미지 프롬프트, 생성 프롬프트, 검토·완료·알림 일시, 작업 URL, 작업 상태 |
| 이메일 안내 | 이메일 주소, 이메일 수신 동의 여부, 메일 제목·본문, 발송 상태, 실패 사유, 발송 요청자, 발송·요청 일시 |
| 푸시 알림 | FCM 토큰, 플랫폼, 기기 식별자, 앱 버전, OS 버전, 활성 여부, 마지막 사용 일시, 알림 제목·본문·이미지 URL·데이터 페이로드, 발송 상태, FCM 메시지 ID, 실패 사유 |
| 결제 및 맞춤 앱 제작 | 주문번호, 결제번호, 결제 금액, 결제 상태, PG사, PG 거래 ID, 결제 결과 코드·메시지, 결제 승인·취소 응답 원문, 제작 신청 번호, 앱 번호·앱명, 주인공 번호·이름, 제작 상태, 결과 URL, 관리자 메모, 신청·완료·취소 일시 |
| 고객지원 및 운영관리 | 문의 내용, 처리 내역, 관리자 처리 이력, 서비스 이용 이력, 작업 이력 |
| 자동 생성 정보 | 접속 IP, 접속 로그, 쿠키 또는 로컬 저장소 식별값, 브라우저·기기 정보, 서비스 이용 기록, 오류 로그 |

## 제3조(14세 미만 아동의 개인정보 처리)

1. 서비스는 보호자가 아동의 주인공 정보를 입력하여 맞춤 동화와 관련 콘텐츠를 생성하는 기능을 포함합니다.
2. 회사는 만 14세 미만 아동이 직접 회원 가입을 하거나 개인정보를 제공하는 경우 법정대리인의 동의를 확인할 수 있습니다.
3. 보호자는 아동의 개인정보, 사진, 초상, 가족·친구 관련 정보를 입력하기 전에 필요한 권한과 동의를 확보해야 합니다.
4. 회사는 아동의 주민등록번호, 상세 주소, 학교명, 연락처, 건강정보 등 서비스 제공에 필요하지 않은 정보를 요구하지 않습니다. 이용자는 이러한 정보를 입력하지 않아야 합니다.
5. 법정대리인은 아동 개인정보의 열람, 정정, 삭제, 처리정지, 동의 철회를 요청할 수 있습니다.

## 제4조(개인정보의 처리 및 보유 기간)

회사는 법령에 따른 개인정보 보유·이용 기간 또는 정보주체로부터 동의받은 기간 내에서 개인정보를 처리·보유합니다.

| 구분 | 보유 기간 |
| --- | --- |
| 회원 가입·로그인 정보 | 회원 탈퇴 시까지. 다만 부정 이용 방지, 분쟁 대응이 필요한 최소 정보는 탈퇴 후 [입력 필요]까지 보관할 수 있습니다. |
| 주인공 프로필, 상세 답변, 동화, 이미지, 프롬프트 | 회원 탈퇴 또는 삭제 요청 시까지. 다만 서비스 제공 완료, 분쟁 대응, 법령상 보존이 필요한 경우 해당 기간까지 보관합니다. |
| 이메일·푸시 발송 이력 | 발송일로부터 [입력 필요]까지. 단, 민원·분쟁 대응 기록은 관련 법령에 따라 3년까지 보관할 수 있습니다. |
| 맞춤 앱 제작 신청 및 제공 기록 | 서비스 제공 완료 및 정산 완료 시까지. 단, 전자상거래 관련 법령에 따른 보존 기간이 적용될 수 있습니다. |
| 결제 및 환불 기록 | 전자상거래 등에서의 소비자보호에 관한 법률에 따라 계약·청약철회, 대금결제 및 재화 등의 공급 기록은 5년까지 보관합니다. |
| 소비자 불만 또는 분쟁처리 기록 | 전자상거래 등에서의 소비자보호에 관한 법률에 따라 3년까지 보관합니다. |
| 표시·광고에 관한 기록 | 전자상거래 등에서의 소비자보호에 관한 법률에 따라 6개월까지 보관합니다. |
| 접속 로그, IP 등 웹사이트 방문 기록 | 통신비밀보호법 등 관계 법령에 따라 3개월까지 보관할 수 있습니다. |

## 제5조(개인정보의 파기 절차 및 방법)

1. 회사는 개인정보 보유 기간의 경과, 처리 목적 달성, 회원 탈퇴, 삭제 요청 등 개인정보가 불필요하게 되었을 때에는 지체 없이 해당 개인정보를 파기합니다.
2. 관계 법령에 따라 보존해야 하는 개인정보는 다른 개인정보와 분리하여 보관하고, 해당 기간이 종료되면 파기합니다.
3. 전자적 파일은 복구 또는 재생할 수 없도록 안전한 방법으로 삭제합니다.
4. 종이 문서는 분쇄하거나 소각하는 방식으로 파기합니다.

## 제6조(개인정보의 제3자 제공)

회사는 정보주체의 개인정보를 제1조의 처리 목적 범위 내에서만 처리하며, 원칙적으로 제3자에게 제공하지 않습니다. 다만 다음 각 호의 경우에는 관련 법령에 따라 개인정보를 제공할 수 있습니다.

1. 정보주체가 사전에 동의한 경우
2. 법률에 특별한 규정이 있거나 법령상 의무를 준수하기 위해 불가피한 경우
3. 수사기관, 법원, 감독기관 등이 적법한 절차에 따라 요청하는 경우
4. 생명, 신체, 재산의 급박한 이익을 위해 필요하고 정보주체의 사전 동의를 받기 어려운 경우

결제 과정에서 이용자가 결제창에 직접 입력하는 카드정보 등 결제수단 정보는 결제대행사의 약관 및 개인정보 처리방침에 따라 처리될 수 있습니다. 회사는 결제 승인·취소 및 정산을 위해 필요한 거래 식별정보와 결제 결과 정보를 결제대행사와 주고받을 수 있습니다.

## 제7조(개인정보 처리업무의 위탁)

회사는 원활한 서비스 제공을 위하여 다음과 같이 개인정보 처리업무를 위탁할 수 있습니다. 회사는 위탁계약 체결 시 개인정보 보호법에 따라 수탁자가 개인정보를 안전하게 처리하도록 관리·감독합니다.

| 수탁자 | 위탁 업무 |
| --- | --- |
| NHN Cloud 또는 TOAST Cloud | 이미지 저장, 오브젝트 스토리지, 이메일 발송, 발송 이력 처리 |
| NICEPAY 또는 NICE페이먼츠 | 결제 승인, 취소, 결제 결과 확인, 정산 지원 |
| Google Firebase Cloud Messaging | 모바일 푸시 알림 발송 |
| OpenAI | 동화, 이미지 설명, 이미지, 음성 등 AI 콘텐츠 생성 |
| 네이버, 카카오, Google | 소셜 로그인 및 계정 식별 연동 |
| 클라우드·호스팅·DB 운영 사업자 | 서버 인프라, 데이터베이스, 보안, 백업 및 장애 대응 |

수탁자와 위탁 업무의 내용이 변경되는 경우 회사는 본 개인정보 처리방침을 통해 공개합니다.

## 제8조(개인정보의 국외 이전)

회사는 서비스 제공 과정에서 다음과 같이 개인정보가 국외로 이전될 수 있습니다. 이용자는 국외 이전을 거부할 수 있으나, 거부 시 해당 외부 연동 기능 또는 AI 생성, 푸시 알림 등 일부 서비스 이용이 제한될 수 있습니다.

| 이전받는 자 | 이전 국가 | 이전 항목 | 이전 목적 | 이전 일시 및 방법 | 보유·이용 기간 |
| --- | --- | --- | --- | --- | --- |
| OpenAI | 미국 등 | 주인공 프로필, 이용자 답변, 동화 생성 프롬프트, 이미지 URL 또는 이미지 입력, 생성 요청·응답 데이터 | AI 기반 동화·이미지·음성·설명 생성 | 이용자가 AI 생성 기능을 이용할 때 암호화된 네트워크로 API 전송 | 수탁자 정책 또는 계약에 따른 기간. 회사는 서비스 제공 목적 달성 시 자체 보유분을 제4조에 따라 처리합니다. |
| Google Firebase Cloud Messaging | 미국 등 | FCM 토큰, 알림 제목·본문, 이미지 URL, 데이터 페이로드 | 푸시 알림 발송 | 푸시 알림 발송 시 암호화된 네트워크로 API 전송 | 수탁자 정책 또는 계약에 따른 기간 |
| Google | 미국 등 | Google 계정 식별자, 이메일 등 로그인 응답 정보 | Google 소셜 로그인 | 로그인 시 암호화된 네트워크로 API 송수신 | 로그인 처리 목적 달성 또는 회원 탈퇴 시까지 |

국외 이전의 세부 내용은 실제 이용 중인 외부 서비스의 계약, 리전, 보관 정책에 따라 달라질 수 있으며, 회사는 변경사항이 발생하면 본 방침을 개정하여 공개합니다.

## 제9조(인공지능 서비스 이용 관련 안내)

1. 회사는 맞춤 동화, 이미지, 음성 및 기타 콘텐츠 생성을 위해 이용자가 입력한 주인공 정보와 답변, 생성 프롬프트, 이미지 URL 등을 AI 서비스에 전송할 수 있습니다.
2. 회사는 서비스 제공에 필요한 범위에서만 AI 서비스에 개인정보를 전송하며, 주민등록번호, 상세 주소, 연락처, 건강정보 등 불필요한 개인정보 또는 민감정보 입력을 요구하지 않습니다.
3. AI 생성 결과는 부정확하거나 부적절한 표현을 포함할 수 있어 회사 또는 이용자의 검토·수정이 필요할 수 있습니다.
4. 회사는 이용자의 권리 또는 의무에 중대한 영향을 미치는 자동화된 결정을 하지 않습니다.

## 제10조(개인정보 자동 수집 장치의 설치·운영 및 거부)

1. 회사는 로그인 상태 유지, 보안, 이용 편의, 서비스 품질 개선을 위해 쿠키, 로컬 저장소 또는 유사 기술을 사용할 수 있습니다.
2. 이용자는 브라우저 또는 기기 설정을 통해 쿠키 저장을 거부하거나 삭제할 수 있습니다. 다만 쿠키 또는 로컬 저장소 사용을 제한하는 경우 로그인 유지 등 일부 기능 이용이 제한될 수 있습니다.
3. 회사는 현재 맞춤형 광고 제공을 목적으로 행태정보를 수집·이용하지 않습니다. 향후 맞춤형 광고를 도입하는 경우 관련 법령에 따라 수집 항목, 이용 목적, 보유 기간, 거부 방법을 공개합니다.

## 제11조(정보주체와 법정대리인의 권리·의무 및 행사 방법)

1. 정보주체와 법정대리인은 회사에 대해 언제든지 개인정보 열람, 정정, 삭제, 처리정지, 동의 철회를 요구할 수 있습니다.
2. 권리 행사는 고객센터 또는 개인정보 보호책임자 연락처를 통해 할 수 있으며, 회사는 본인 또는 정당한 대리인 여부를 확인한 뒤 지체 없이 조치합니다.
3. 정보주체가 개인정보 오류에 대한 정정을 요청한 경우, 회사는 정정을 완료하기 전까지 해당 개인정보를 이용하거나 제공하지 않습니다.
4. 법령상 보존 의무가 있거나 다른 법령에서 정한 사유가 있는 경우 회사는 삭제 또는 처리정지 요청을 제한할 수 있습니다.
5. 이용자는 본인 또는 보호 권한이 있는 아동·제3자의 정보만 입력해야 하며, 입력 정보가 정확하고 최신 상태가 되도록 관리해야 합니다.

## 제12조(개인정보의 안전성 확보조치)

회사는 개인정보의 안전성 확보를 위해 다음과 같은 조치를 취합니다.

1. 개인정보 접근 권한의 최소화 및 접근 통제
2. 개인정보 처리 시스템 접속기록의 보관 및 점검
3. 비밀번호, 접근 토큰, API 키 등 인증정보의 안전한 관리
4. 개인정보의 전송 구간 암호화
5. 보안 프로그램, 서버 및 인프라 보안 업데이트
6. 내부 관리계획 수립 및 개인정보 취급자 교육
7. 장애, 침해사고 및 개인정보 유출 대응 절차 운영

## 제13조(개인정보 보호책임자)

회사는 개인정보 처리에 관한 업무를 총괄하고 개인정보 관련 고충을 처리하기 위하여 아래와 같이 개인정보 보호책임자를 지정합니다.

- 개인정보 보호책임자: 김빛나라
- 직책/부서: 대표
- 이메일: tbroskor@gmail.com
- 주소: 제주 서귀포시 번영로 3376

개인정보 관련 문의, 열람·정정·삭제·처리정지 요청, 피해구제 요청은 위 연락처로 문의할 수 있습니다.

## 제14조(권익침해 구제 방법)

정보주체는 개인정보 침해에 대한 상담 또는 피해구제를 위해 아래 기관에 문의할 수 있습니다.

1. 개인정보침해신고센터: 국번 없이 118, https://privacy.kisa.or.kr
2. 개인정보분쟁조정위원회: 1833-6972, https://www.kopico.go.kr
3. 대검찰청: 국번 없이 1301, https://www.spo.go.kr
4. 경찰청 사이버범죄 신고시스템: 국번 없이 182, https://ecrm.police.go.kr

## 제15조(개인정보 처리방침의 변경)

1. 회사는 법령, 서비스, 위탁 업무, 개인정보 처리 항목이 변경되는 경우 본 개인정보 처리방침을 개정할 수 있습니다.
2. 본 방침을 변경하는 경우 회사는 변경 내용과 시행일을 서비스 화면 또는 공지사항을 통해 공개합니다.
3. 이 개인정보 처리방침은 2026-06-01부터 적용됩니다.

## 부칙

이 개인정보 처리방침은 2026-06-01부터 시행합니다.
`,
  },
}
